;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/certificates/verify/:publicNumber\",\"regex\":\"^/certificates/verify/([^/]+)$\",\"paramNames\":[\"publicNumber\"],\"hasOptionalPrefix\":false},{\"path\":\"/history/:item\",\"regex\":\"^/history/([^/]+)$\",\"paramNames\":[\"item\"],\"hasOptionalPrefix\":false},{\"path\":\"/project/:slug\",\"regex\":\"^/project/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:project\",\"regex\":\"^/projects/([^/]+)$\",\"paramNames\":[\"project\"],\"hasOptionalPrefix\":false},{\"path\":\"/projects/:project/edit\",\"regex\":\"^/projects/([^/]+)/edit$\",\"paramNames\":[\"project\"],\"hasOptionalPrefix\":false},{\"path\":\"/tools/:tool\",\"regex\":\"^/tools/([^/]+)$\",\"paramNames\":[\"tool\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/about\"},{\"path\":\"/account\"},{\"path\":\"/assistant\"},{\"path\":\"/auth/email/confirm\"},{\"path\":\"/auth/login-link\"},{\"path\":\"/certificates\"},{\"path\":\"/certificates/verify\"},{\"path\":\"/checkout/cancel\"},{\"path\":\"/checkout/success\"},{\"path\":\"/history\"},{\"path\":\"/payment/checkout/cancel\"},{\"path\":\"/payment/checkout/success\"},{\"path\":\"/projects\"},{\"path\":\"/projects/new\"},{\"path\":\"/sentry-sourcemap-probe\"},{\"path\":\"/tools\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.1";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

/**
 * Browser SDK init. Loaded automatically by Next.js.
 * Operational app logs stay on the server (stderr → Filebeat → OpenSearch).
 * Sentry here is for client exceptions / optional performance traces only.
 */
Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment:
    process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? process.env.NODE_ENV,

  // Errors always; keep traces cheap in production.
  tracesSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.1,

  // Clinical product: do not attach default PII (IP, etc.).
  sendDefaultPii: false,

  // Do not ship structured logs to Sentry — OpenSearch owns that channel.
  enableLogs: false,

  ignoreErrors: [
    "ResizeObserver loop completed with undelivered notifications",
    "ResizeObserver loop limit exceeded",
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
